export const SHAPESHIFT_COSMOS_VALIDATOR_ADDRESS =
  'cosmosvaloper199mlc7fr6ll5t54w7tts7f4s0cvnqgc59nmuxf'
